import Everest from "../media/machhapuchre.jpg"

export const projectData = [
    {
        proName: "DE MACHHAPUCHHARE PARADISE",
        topList: [
            { key: "Location", value: "16 km from Prithvi Chowk, Pokhara" },
            { key: "Land area", value: "34 Ropani" }
        ],
        tagLine: "A Unique Eco-Resort Experience",
        image: Everest,
        overview: `DE MACHHAPUCHHARE PARADISE is an upcoming eco-resort nestled in the serene hills of Pokhara, offering a unique blend of agro-tourism, adventure, and relaxation. Spread across 34 ropani of lush land, the resort is designed to provide an unforgettable experience for guests while promoting sustainable practices and community development. Just 16 km from Prithvi Chowk, the resort is easily accessible yet feels like a world away from the hustle and bustle of city life.
We’re not just building a resort — we’re building a sustainable community. From the architecture to employment, we believe in giving back.
We’ve created spaces that not only blend into the natural environment but also awaken your senses. At DE MACHHAPUCHHARE PARADISE, you don’t just stay — you live the moment.
`,
    features: {
      "Accommodation Options": [
        {
          key: "Mountain View Cottages",
          value:
            "Spacious cottages with private balconies offering panoramic views of the Himalayas. Each cottage is designed to provide comfort and luxury, ensuring a memorable stay.",
        },
        {
          key: "Village-Style Eco-Huts",
          value:
            "Traditional Nepali-style huts made from sustainable materials, blending seamlessly with the natural environment. These eco-huts offer a unique cultural experience.",
        },
        {
          key: "Treehouses",
          value:
            "Hidden among the trees, these treehouses provide an intimate connection with nature, perfect for nature lovers seeking a unique experience.",
        },
        {
          key: "Luxury Glamping Tents",
          value:
            "Rustic yet comfortable, these glamping tents offer a blend of outdoor adventure and modern amenities, ensuring a luxurious camping experience.",
        },
        {
          key: "Campgrounds",
          value:
            "Ideal for those who prefer the open sky and bonfires, our campgrounds provide a more rustic experience with basic facilities.",
        },
      ],
      "Agro-Tourism Experience": [
        {
          key: "Organic Farm",
          value:
            "At the heart of the resort lies a vibrant, working organic farm. Guests can participate in seasonal farming activities, learn from local farmers, and experience the rhythm of the land.",
        },
        {
          key: "Cultural Demos",
          value:
            "Discover the charm of village life through cultural demonstrations and folk stories. Join us during rice planting and harvesting festivals for a deeper immersion into local traditions.",
        },
        {
          key: "Farm-to-Fork Dining",
          value:
            "Enjoy authentic, locally-sourced meals prepared by our farm chefs. Dine on fresh produce straight from our organic farm, ensuring a truly unique culinary experience.",
        },
      ],
      "Adventure Activities": [
        {
          key: "Zip-lining",
          value:
            "Soar above the forest with Machhapuchhare as your backdrop, experiencing the thrill of zip-lining in a breathtaking setting.",
        },
        {
          key: "Rock Climbing & Rappelling",
          value:
            "Challenge yourself on natural rock formations, with experienced guides ensuring your safety and enjoyment.",
        },
        {
          key: "Horseback Riding",
          value:
            "Ride along scenic rural paths, enjoying the beauty of the surrounding landscapes.",
        },
        {
          key: "Nature Walks & Bird Watching",
          value:
            "Discover hidden trails and observe local wildlife with expert guides, making every step an adventure.",
        },
        {
          key: "Yoga & Meditation",
          value:
            "Recharge your soul with serene yoga decks and meditation spaces, offering a peaceful retreat for mindfulness and relaxation.",
        },
      ],
      "Sustainability & Community": [
        {
          key: "Eco-Conscious Design",
          value:
            "The resort is designed with sustainability in mind, featuring zero-plastic policies and the use of sustainable building materials.",
        },
        {
          key: "Solar & Rainwater Systems",
          value:
            "Harnessing renewable energy and conserving water, the resort is committed to minimizing its environmental footprint.",
        },
        {
          key: "Local Employment",
          value:
            "Creating job opportunities for the local community, supporting economic development and social well-being.",
        },
        {
          key: "Cultural Preservation",
          value:
            "Workshops and festivals are organized to preserve and promote local heritage, ensuring the cultural richness of the region is maintained.",
        },
      ],
    },
    investment: {
      "Strategic Location": [
        {
          key: "Proximity to Pokhara",
          value:
            "Just 16 km from Prithvi Chowk, the resort offers easy accessibility while maintaining a serene and secluded environment.",
        },
        {
          key: "Tourist Destination",
          value:
            "Capitalize on the growing tourism industry in Pokhara, a major tourist hub in Nepal.",
        },
      ],
      "Market Potential": [
        {
          key: "Growing Demand",
          value:
            "Increasing interest in eco-tourism and adventure travel, with a growing number of travelers seeking sustainable and unique experiences.",
        },
        {
          key: "Dual Revenue Streams",
          value:
            "Revenue from accommodation, activities, dining, and potential eco-tourism initiatives, ensuring a diversified income.",
        },
      ],
      "Community Support": [
        {
          key: "Local Partnerships",
          value:
            "Strong relationships with local communities and authorities, ensuring smooth operations and community support.",
        },
        {
          key: "Sustainable Practices",
          value:
            "Commitment to environmental and social sustainability, enhancing the resort’s appeal to eco-conscious travelers.",
        },
        {
          key: "Funding Options",
          value:
            "Equity investment, debt financing, and government incentives available to support your investment.",
        },
      ],
    },
    whyUs: [
      {
        key: "Unique Experience",
        value:
          "Offer guests a blend of adventure, relaxation, and cultural immersion, creating unforgettable memories.",
      },
      {
        key: "Growing Market",
        value:
          "Capitalize on the rising trend of eco-tourism and sustainable travel, tapping into a growing market segment.",
      },
      {
        key: "Strategic Location",
        value:
          "Benefit from the high tourist traffic in Pokhara, ensuring a steady flow of visitors.",
      },
      {
        key: "Community Impact",
        value:
          "Support local development and environmental sustainability, contributing to the region’s socio-economic growth.",
      },
      {
        key: "High Returns",
        value:
          "Attractive financial projections with a strong potential for growth and high returns on investment.",
      },
    ],
  
        contact: [
            { key: "Email", value: "info@demachhapuchhareparadise.com" },
            { key: "Phone", value: "+977-9851410058" }
        ]
    },
    {
        proName: "Gulangdi Small Hydropower Project",
        tagLine: "A Sustainable Investment Opportunity",
        topList: [
            { key: "Location", value: "Gulmi District, Nepal" },
            { key: "Capacity", value: "980 KW" }
        ],
        image:
            "https://brahmajyotienergy.com/wp-content/uploads/2025/04/viber_image_2025-04-08_13-34-02-105-1024x1024.jpg",
        overview:
            "The Gulangdi Small Hydropower Project is a state-of-the-art renewable energy initiative designed to harness the region’s abundant water resources. Strategically located in the picturesque Gulmi District, this project offers a unique blend of modern technology and sustainable practices, making it an attractive investment opportunity. Brahma Jyoti Holdings Limited (BJHL), a prominent public Holdings company, has secured over 85% of the project's total equity. This substantial financial commitment underscores BJHL's dedication to advancing Nepal's energy infrastructure. The project is currently under construction and is expected to be completed within the next 15 months, marking a significant milestone in the region's energy development.",
        projectDetails: [
            { key: "River Source", value: "The project utilizes the waters of the Gulangdi River, a tributary of the West Seti River, known for its consistent flow and potential for hydroelectric generation." },
            { key: "Technology", value: "The project employs modern, efficient turbines and generators to maximize energy production while minimizing environmental impact." },
            { key: "Infrastructure", value: "The project includes a small dam, a diversion channel, and a powerhouse equipped with advanced technology." },
            { key: "Capacity", value: "980 kW, capable of generating a significant amount of clean, renewable energy." },
            { key: "Environmental Impact", value: "A clean energy source that contributes to reducing carbon emissions and promoting sustainable development." },
            { key: "Market Potential", value: "High demand for electricity in the region, with potential for sales to the national grid." },
            { key: "Community Benefits", value: "Supports local economic development and job creation, enhancing the region’s socio-economic landscape." }
        ],
        features: [
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." },
            { key: "Modern Facilities", value: "Designed with durability and efficiency in mind, ensuring long-term sustainability." },
            {
                key: "Revenue Streams",
                value: [
                    "Electricity sales to the national grid.",
                    "Potential for additional revenue through eco-tourism and community engagement initiatives."
                ]
            },
            { key: "Community Support", value: "Strong local support and partnerships for sustainable development." }
        ],
        investment: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "High Demand", value: "Capitalize on the growing need for reliable electricity in the region." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Funding Options", value: "Various funding options are available, including equity investment, debt financing, and government incentives." }
        ],
        environmentalImpact: [
            { key: "Sustainable Practices", value: "The project adheres to strict environmental standards, ensuring minimal impact on local ecosystems." },
            { key: "Community Engagement", value: "The project includes initiatives to support local communities, such as job creation, skill development, and community infrastructure projects." },
            { key: "Climate Change Mitigation", value: "By generating clean energy, the project helps reduce carbon emissions and supports global efforts to combat climate change." }
        ],
        whyUs: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "High Demand", value: "Capitalize on the growing need for reliable electricity in the region." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." }
        ]
    }
];